import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { TranslateService } from "@ngx-translate/core";
import { CommonService } from "src/app/core/services/common.service";
import { TokenService } from "src/app/core/services/token.service";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { ImportDatosAccesoriosService } from "../import-datos-accesorios.service";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { AppConstants } from "src/app/constants/app.constants";

@Component({
  selector: "app-uploading-page",
  templateUrl: "./uploading-page.component.html",
  styleUrls: ["./uploading-page.component.scss"],
})
export class UploadingPageComponent implements OnInit {
  public datosAccesorios;
  public lastModifiedDate;
  public mensajeSwalPopup;
  public iconSwalPopup;
  public uploadSuccess = false;

  @ViewChild("uploadSwal")
  public readonly uploadSwal!: SwalComponent;

  private router: Router;
  public routing = RoutingConstants.exportarHistoricoPlaca;

  files = {
    file: undefined,
  };

  constructor(
    private importDatosAccesoriosService: ImportDatosAccesoriosService,
    private toastrAlertService: ToastrAlertService,
    private sweetAlertService: SweetAlertService,
    private commonService: CommonService,
    private tokenService: TokenService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.initFormGroup();
    this.getLastModDate();
  }

  initFormGroup() {
    this.datosAccesorios = new FormGroup({
      archivo: new FormControl("", [Validators.maxLength(64)]),
      glValor: new FormControl("", [Validators.maxLength(64)]),
      glNombre: new FormControl("", [Validators.maxLength(64)]),
    });
  }

  handleFileInput(fileInput: any) {
    this.files.file = undefined;
    if (fileInput.target.files && fileInput.target.files[0]) {

      if(Array.from(fileInput.target.files).filter((file:File) => file.name.length > AppConstants.maximaLongitudNombreFichero).length > 0) {
        let message = this.translateService.instant("messages.maxFileNameExceeded");
        this.toastrAlertService.toastrFail(message);
        return;
      }

      if(Array.from(fileInput.target.files).filter((file:File) => file.size > AppConstants.tamanyoMaximoFicheroEnBytes).length > 0) {
        let message = this.translateService.instant("messages.maxFileSizeExceeded");
        this.toastrAlertService.toastrFail(message);
        return;
      }

      this.files.file = fileInput.target.files[0].name;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.setFileEsp(e.target.result);
      };

      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }

  setFileEsp(imgBase64) {
    let blob = this.commonService.castToBlob(imgBase64);
    this.datosAccesorios.patchValue({
      archivo: blob,
    });
  }

  getLastModDate() {
    this.importDatosAccesoriosService.getUltimaCargaFichero().subscribe(
      (data) => {
        this.datosAccesorios.patchValue({
          glValor: data["glValor"],
          glNombre: data["glNombre"],
        });
      },
      (err) => {
        this.toastrAlertService.toastrFail(
          err.error.mensaje
            ? err.error.mensaje
            : "Error al cargar ultima modificación"
        );
      }
    );
  }

  resetMensajeBackRevertir() {
    this.mensajeSwalPopup = undefined;
    this.iconSwalPopup = undefined;
  }

  onDownload() {
    let filterName = this.createFileName();

    this.importDatosAccesoriosService.getFile().subscribe(
      (data) => {
        this.commonService.downloadFile(data, filterName);

        this.toastrAlertService.toastrSuccess("Archivo descargado");
      },
      (err) => {
        this.toastrAlertService.toastFailBlob(err.error);
      }
    );
  }

  createFileName(): string {
    let retFileName = "DatosAccesorios_";
    if (this.datosAccesorios.value.glValor) {
      retFileName =
        retFileName + "FechaUltimaCarga-" + this.datosAccesorios.value.glValor;
    }
    retFileName = retFileName + ".xls";
    return retFileName;
  }

  onImport() {
    this.mensajeSwalPopup = undefined;
    this.iconSwalPopup = undefined;

    if (this.datosAccesorios.value.archivo) {
      this.importDatosAccesoriosService
        .importArchivoFrm(this.datosAccesorios)
        .subscribe(
          (data) => {
            this.sweetAlertService.sweetAlertSuccess(
              data["mensaje"] ? data["mensaje"] : "Archivo actualizado"
            );
            this.getLastModDate();
          },
          (err) => {
            this.toastrAlertService.toastrFail(
              err.error.mensaje
                ? err.error.mensaje
                : "Error al cargar subir el archivo"
            );
          }
        );
    } else {
      this.toastrAlertService.toastrFail("No archivo encontrado");
    }
    this.datosAccesorios.value.archivo = null;
    this.files.file = null;
  }

  onRevert() {
    this.mensajeSwalPopup = undefined;
    this.iconSwalPopup = undefined;

    this.importDatosAccesoriosService.getRestore().subscribe(
      (data) => {
        this.iconSwalPopup = "success";
        this.mensajeSwalPopup = data["mensaje"]
          ? data["mensaje"]
          : "Cambios Revertidos";
        this.uploadSwal.html = data["mensaje"];
        this.uploadSwal.fire();
      },
      (err) => {
        this.toastrAlertService.toastrFail(
          err.error.mensaje ? err.error.mensaje : "Error al revertir el archivo"
        );
      }
    );
    this.getLastModDate();
  }

  goPredefinedMailBox() {
    this.tokenService.redirectPredefinedMailBox();
  }
}
